import { API_ENDPOINTS } from "../api-urls";
import axios from "axios";
import homeDataJson from "../Assets/home-dikost.json"
const fetchHomeData = async () => {
  try {
    console.log("Fetching data..."); // Log before API call

    const response = await axios.get(API_ENDPOINTS.home);

    console.log("Full API Response:", response); // Log the full response object

    if (response.status === 200) {
      console.log("API Response Data:", response.data); // Log the actual data
      console.log("---------------------------------", response.data["data"]); // Log the actual data


      // setSections(response.data.data);

      // // Extract Banner Data
      // const bannerSection = response.data.data.find(
      //   (section) => section.structure_type === "banner"
      // );
      // if (bannerSection) {
      //   console.log("Banner Data Found:", bannerSection.data);
      //   setBannerData(bannerSection.data);
      // }
      // return homeDataJson.data;
      return response.data.data;
    } else {
      console.error("Unexpected Response Status:", response.status);
      return response.data.data;
    }
    // console.log("setted data-------------------", sections);
  } catch (error) {
    console.error(
      "Error fetching data:",
      error.response ? error.response.data : error.message
    );
  }
};


export {fetchHomeData};